import { Box } from "@mui/material";

const Spacer = ({ height = "110px" }: { height?: string }) => (
  <Box
    sx={{
      height,
      minHeight: 0,
      flexShrink: 0,
      width: "100%",
      display: "block",
      backgroundColor: "transparent",
      border: "none",
      margin: 0,
      padding: 0,
    }}
  />
);

export default Spacer;
